<template>
    <div>
        <div class="row py-lg-4">
            <NewsCard
                v-for="blogsItem in blogsItems"
                :key="blogsItem.id"
                :news-item="blogsItem"
            ></NewsCard>
        </div>
        <div
            v-show="showMore"
            class="py-3 row block-news-overview_button-row text-center"
        >
            <button
                class="btn btn-primary mx-auto"
                name="load-more"
                @click="nextPage"
            >
                Meer nieuws laden
            </button>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import NewsCard from '@/components/news/news-card';

export default {
    components: {
        NewsCard
    },
    data() {
        return {
            blogsItems: [],
            page: 1,
            showMore: false
        };
    },
    watch: {
        page() {
            this.getBlogs();
        }
    },
    created() {
        this.getBlogs();
    },
    methods: {
        getBlogs() {
            axios({
                method: 'get',
                url:
                    '/api/BlogsApi/list?' +
                    this.$root.settings.nodeId +
                    '&page=' +
                    this.page
            })
                .then(response => {
                    if (!response.data === null) {
                        return false;
                    }

                    this.blogsItems = this.blogsItems.concat(
                        response.data.pagedResults
                    );

                    this.showMore = response.data.showMore;

                    return true;
                })
                .catch(() => false);
        },
        nextPage() {
            this.page += 1;
        }
    }
};
</script>

<style lang="scss" scoped>
.block-news-overview_button-row {
    background-color: $color-gray;
}
</style>
